// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--dpLxY","wrapper":"_9330de7794--wrapper--cYy68","title":"_9330de7794--title--cI7lr","tabs":"_9330de7794--tabs--dvNqB"};